var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPromotions = function SvgPromotions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "promotions_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".promotions_svg__cls-2,.promotions_svg__cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:14px}.promotions_svg__cls-2{stroke:#fff}.promotions_svg__cls-3{stroke:#ed1c24}"))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7ac142"
    },
    d: "M-1.28.24h500.3v500.55H-1.28z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "promotions_svg__discount"
  }, /*#__PURE__*/React.createElement("path", {
    className: "promotions_svg__cls-2",
    d: "m218.16 107.9 3.81-5.4h85.73l57.16 81v204.8a9.53 9.53 0 0 1-9.53 9.53h-181a9.53 9.53 0 0 1-9.52-9.53V183.47l26.62-37.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "promotions_svg__cls-3",
    d: "m293.41 243.01-57.15 95.25"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "promotions_svg__cls-3",
    cx: 234.26,
    cy: 262.06,
    r: 19.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "promotions_svg__cls-3",
    cx: 295.41,
    cy: 319.21,
    r: 19.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "promotions_svg__cls-2",
    d: "M276 136.81a20.69 20.69 0 1 1-31.18 17.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "promotions_svg__cls-2",
    d: "M145.62 179.36c-22.75-5-38-14.09-38-24.47 0-15.78 35.18-28.57 78.59-28.57s78.59 12.79 78.59 28.57"
  }))));
};
export default SvgPromotions;